/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MatchQuestion } from '../../models/match-question';

export interface UpdateMatchQuestion$Params {
  id: string;
      body?: MatchQuestion
}

export function updateMatchQuestion(http: HttpClient, rootUrl: string, params: UpdateMatchQuestion$Params, context?: HttpContext): Observable<StrictHttpResponse<MatchQuestion>> {
  const rb = new RequestBuilder(rootUrl, updateMatchQuestion.PATH, 'put');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<MatchQuestion>;
    })
  );
}

updateMatchQuestion.PATH = '/matchquestion/{id}';
